<script lang="ts" setup>
/*---------------------------------------------
/  PROPS & EMITS
---------------------------------------------*/
/*---------------------------------------------
/  VARIABLES
---------------------------------------------*/
const router = useRouter();
const route = useRoute();
const footerVisible = ref<boolean>(false);
let footerVisibleTimeout: ReturnType<typeof setTimeout>;
const userStore = useUserStore();
/*---------------------------------------------
/  METHODS
---------------------------------------------*/
/*---------------------------------------------
/  COMPUTED
---------------------------------------------*/
/*---------------------------------------------
/  WATCHERS
---------------------------------------------*/
/*---------------------------------------------
/  CREATED
---------------------------------------------*/
router.beforeEach(() => {
	footerVisible.value = false;
});
router.afterEach(() => {
	clearTimeout(footerVisibleTimeout);

	footerVisibleTimeout = setTimeout(() => {
		footerVisible.value = true;
	}, 500);
});
/*---------------------------------------------
/  HOOKS
---------------------------------------------*/
onMounted(async () => {
	console.log('[route]: ', route.path);
	// await fetcher(userStore.authenticate());
});
</script>
<template>
	<Meta />
	<Transition
		name="router-fade"
		mode="in-out">
		<Header v-if="userStore.user || route.name === 'survey-public'"></Header>
	</Transition>
	<main>
		<router-view v-slot="{ Component }">
			<transition
				name="router-fade"
				mode="out-in">
				<component :is="Component" />
			</transition>
		</router-view>
	</main>
	<Transition>
		<Footer v-if="footerVisible && userStore.user"></Footer>
	</Transition>
</template>
<style src="./App.scss">
</style>
